import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { Guard } from '../../components/layout/Guard';

const SettingsPage = lazy(() => import('./SettingsPage'));

const routes: RouteObject[] = [{ path: '/settings', element: <Guard any={['settings.manage']}><SettingsPage /></Guard> }];
export default routes;
